import { useNavigate } from "react-router-dom";
import { useMapContext } from "../context/MapContext";

export const useContextMenuNavigation = () => {
	const navigate = useNavigate();
	const {
		state: { menuContextAssetId },
	} = useMapContext();

	const handleClickAssetDetails = () => {
		navigate(
			`/asset-details/${menuContextAssetId}?resource=documents&assets=true&statistics=true&workOrders=true`,
			{ replace: true },
		);
	};

	const handleClickAssetDocuments = () => {
		navigate(
			`/asset-details/${menuContextAssetId}?resource=documents&assets=true&statistics=false&workOrders=false`,
			{ replace: true },
		);
	};

	const handleClickAssetParts = () => {
		navigate(
			`/asset-details/${menuContextAssetId}?resource=parts&assets=true&statistics=false&workOrders=false`,
			{ replace: true },
		);
	};

	const handleClickAssetAssemblies = () => {
		navigate(
			`/asset-details/${menuContextAssetId}?resource=assemblies&assets=true&statistics=false&workOrders=false`,
			{ replace: true },
		);
	};

	const handleClickAssetLOTO = () => {
		navigate(
			`/asset-details/${menuContextAssetId}?resource=loto&assets=true&statistics=false&workOrders=false`,
			{ replace: true },
		);
	};

	const handleClickAssetText = () => {
		navigate(
			`/asset-details/${menuContextAssetId}?resource=text&assets=true&statistics=false&workOrders=false`,
			{ replace: true },
		);
	};

	const handleClickAttachment = () => {
		navigate(
			`/asset-details/${menuContextAssetId}?resource=attachments&assets=true&statistics=false&workOrders=false`,
			{ replace: true },
		);
	};
	const handleClickGrid = () => {
		navigate(
			`/asset-details/${menuContextAssetId}?resource=grid&assets=true&statistics=false&workOrders=false`,
			{ replace: true },
		);
	};
	const handleClickWorkOrders = () => {
		navigate(
			`/asset-details/${menuContextAssetId}?resource=documents&assets=false&statistics=false&workOrders=true`,
			{ replace: true },
		);
	};
	const handleClickQCBD = () => {
		navigate(
			`/asset-details/${menuContextAssetId}?resource=qcbd&assets=true&statistics=false&workOrders=false`,
			{ replace: true },
		);
	};

	return {
		handleClickAssetDetails,
		handleClickAssetDocuments,
		handleClickAssetParts,
		handleClickAssetAssemblies,
		handleClickAssetLOTO,
		handleClickAttachment,
		handleClickGrid,
		handleClickAssetText,
		handleClickWorkOrders,
		handleClickQCBD,
	};
};
